export default __webpack_public_path__ + "i18n/translations/translation-he.91fbce4e.json";